import { useGetList, useGetOne } from 'react-admin';

// Same dual-id idea as useNativeLineItem (MD-5185): PIO API is dead, so campaign
// reads for legacy numeric ids must resolve from native `campaigns` via externalPioId.
const nativeCampaignIdPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isNativeCampaignId = (value: string | number | null | undefined) => {
  if (value === null || value === undefined || value === '') return false;
  return nativeCampaignIdPattern.test(String(value));
};

export const useNativeCampaign = (anyCampaignId: string | number | null | undefined) => {
  const id =
    anyCampaignId === null || anyCampaignId === undefined || anyCampaignId === ''
      ? undefined
      : String(anyCampaignId);
  const isNative = isNativeCampaignId(id);

  const one = useGetOne('campaigns', { id: id as string }, { enabled: Boolean(id) && isNative });
  // Explicit equalTo: ra-postgraphile maps a plain string filter value to includes.
  const list = useGetList(
    'campaigns',
    {
      filter: { externalPioId: { operator: 'equalTo', value: id }, includeArchived: true },
      pagination: { page: 1, perPage: 1 },
      sort: { field: 'id', order: 'ASC' },
    },
    { enabled: Boolean(id) && !isNative },
  );

  if (!id) {
    return { campaign: undefined, isLoading: false, error: undefined as Error | undefined };
  }

  if (isNative) {
    return { campaign: one.data, isLoading: one.isLoading, error: one.error ?? undefined };
  }

  const campaign = list.data?.[0];
  const notFoundError =
    !list.isLoading && !list.error && list.data && !campaign
      ? new Error(`Campaign not found: ${id}`)
      : undefined;

  return { campaign, isLoading: list.isLoading, error: list.error ?? notFoundError };
};
